import { ReactNode } from "react";

import { Logo } from "../../../../components/global";
import "../../index.scss";
import BackToLoginButton from "./_back-to-login-button";

type AccessLimitLayoutProps = {
  title: string;
  description: ReactNode;
};

const AccessLimitLayout = ({ title, description }: AccessLimitLayoutProps) => (
  <div className="auth-section">
    <Logo variant="lex" />
    <h2>{title}</h2>
    <p className="w-50 flex justify-center text-center">{description}</p>

    <BackToLoginButton />
  </div>
);

export default AccessLimitLayout;
